// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClaimLookupsAdjudicationCodeLookupModel } from './claimLookupsAdjudicationCodeLookupModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1TypesReasonCodesResponse {
    'data': Array<ClaimLookupsAdjudicationCodeLookupModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1TypesReasonCodesResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<ClaimLookupsAdjudicationCodeLookupModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1TypesReasonCodesResponse.attributeTypeMap;
    }
}
